// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1roe9","question":"styles_question__VKG9N","description":"styles_description__19Un0"};